import type { OptionProps } from "components/common/utlis/TypeAnnotations";

export interface JobApplicationData {
  office: string;
  absJobsCv: string;
  date: string;
  candidate: string;
  vacancyName: string;
  channel: string;
  status: string;
  applicationId: number;
  email: string;
  phone: string;
  companyName: string;
  companyId: number;
  companyCity: string;
  vacancyId: number;
  candidateId: number;
}

export interface JobApplicationSearchData {
  office: number[];
  candidateName: string;
  channel: string;
  email: string;
  phone: string;
  from: Date | null | string;
  to: Date | null | string;
  companyName: OptionProps[];
  city: string[];
  vacancyName: string;
  orderByColumn: string;
  orderIn: "" | "asc" | "desc"; // Ensure correct typing here
  currentPage: number;
  recordsPerPage: number;
  type: number;
}

export const intialJobApplicationSearchData: JobApplicationSearchData = {
  office: [],
  candidateName: "",
  channel: "",
  email: "",
  phone: "",
  from: "",
  to: "",
  companyName: [],
  city: [],
  vacancyName: "",
  orderByColumn: "",
  orderIn: "",
  currentPage: 1,
  recordsPerPage: 10,
  type:1
};

export interface dropDownList {
  offices: OptionProps[];
  cities: OptionProps[];
}

export const intialDropDownList: dropDownList = {
  offices: [] as OptionProps[],
  cities: [] as OptionProps[],
};
